var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("img", {
    staticClass: "icon icon-svg",
    attrs: {
      src: require("@/static/svg/icono_editar_circulo.svg"),
      alt: "next"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }